import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/docs/global-architecture.png")